<!--
 * @Author: your name
 * @Date: 2021-01-06 17:09:46
 * @LastEditTime: 2021-01-06 21:35:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\problem\info.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link target="_blank" class="routerLink" to="/home"
        >阳光校务服务大厅
        </router-link>&gt;
        <router-link target="_blank" class="routerLink" to="/problem">常见问题
        </router-link>&gt; 正文
      </div>
    </div>
    <div class="orgTitle center">{{ record.name }}</div>
    <div class="orgTime center">
      文字来源：本站原创  发布时间： {{ record.gmtCreate }}
    </div>
    <div style="width: 100%;padding: 25px">
      问题内容：<span>{{ record.name }}</span>
    </div>
    <div style="width: 100%;padding: 25px">
      <span style="float:left;">回复：</span>
      <span style="float: left" v-if="record.replyLogs?record.replyLogs.length>0:false">
      <a-timeline>
            <a-timeline-item v-for="(item,index) in record.replyLogs" :key="index">
              【{{ item.orgName }}】： {{ item.reply }} -- {{ item.gmtCreate }}
            </a-timeline-item>
          </a-timeline>
    </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      record: {},
    };
  },
  methods: {},
  mounted() {
    this.record = JSON.parse(decodeURIComponent(this.$route.query.record));
  },
};
</script>

<style scoped>
.center {
  width: 100%;
  text-align: center;
}

.orgTitle {
  padding-top: 20px;
  font-family: 宋体;
  font-size: 22pt;
  font-weight: bold;
}

.orgTime {
  padding-top: 10px;
  font-size: 12px;
  color: #999;
}

.orgTitle2 {
  font-weight: bold;
  margin-top: 15px;
  font-family: 仿宋_GB2312;
  font-size: 14pt;
}
</style>
